/*
 * @Author: niuqingxia
 * @Date: 2024-12-19 18:13:44
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-12-Mo 01:59:56
 仪表盘
 */

<template>
  <div id="gaugeNumber" class="gauge" :style="{width: config.chartWidth+'px',height:config.chartHeight+'px'}">
    <div ref="gauge" class="gauge-container"></div>
    <div
      class="gauge-chart-title"
      :style="{
        textAlign: config.chartSet.titleStyle.align,
        fontSize: config.chartSet.titleStyle.fontSize + 'px',
        color: config.chartSet.titleStyle.color,
      }">
      {{ config.chartTitle }}
      <el-tooltip v-if="config.chartViewData.showIndicator" class="item" :open-delay="500" effect="dark" placement="top">
        <div slot="content" v-html="indicatorDescription"></div>
        <i class="el-icon-question"></i>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import * as echarts from 'echarts'
import { COLOR_LIST } from '@/utils/defaultColorData'
import { getNumberFormat } from '@/utils/common'
import { gaugeBaseOption } from '../options'
import ChartMixin from '../mixin'
export default {

  name: 'Gauge',
  mixins: [ChartMixin],
  props: {
    config: {
      type: Object,
    },
    componentType: {
      type: String,
    },
    globalConfig: {
      type: Object,
    },

  },
  data () {
    return {
      option: {},
      COLOR_LIST,
      echarts: null,
    }
  },
  computed: {
    // 表格数据
    chartData () {
      return this.config.chartViewData.chartData
    },
    curNumber () {
      if (!this.chartData?.length) return
      // 除第一列(维度)之外的所有表头key集合 keyList
      const colKeyList = Object.keys(this.chartData[0])
      // 表格数据 (去除第一行(表头))
      const tableData = this.chartData.slice(1)
      return tableData[0][colKeyList[0]] // 第一个单元格数据
    },
    borderColor () {
      return this.config.chartSet.borderStyle.color
    },

  },
  watch: {

    // 数据变更时
    chartData: {
      handler: function (val) {
        this.init()
      },
      deep: true,
    },

    // 配置项变更
    config: {
      handler: function () {
        this.init()
        //  仪表盘 resize
        this.$nextTick(() => {
          this.echarts.resize()
        })
      },
      deep: true,
    },
    // 全局样式监听
    'globalConfig.chartColors': {
      handler () {
        this.config.chartSet.borderStyle.color = COLOR_LIST.filter(item => { return item.label === this.globalConfig.chartColors })[0].value[0]
      },
      deep: true,
    },

  },
  mounted () {
    if (!this.echarts) {
      this.echarts = echarts.init(this.$refs.gauge, 'dark')
    }
    this.init()
  },
  created () {
    this.config.chartSet.borderStyle.color = COLOR_LIST.filter(item => { return item.label === this.globalConfig.chartColors })[0].value[0]
  },
  beforeDestroy () {
    if (this.echarts) {
      this.echarts.dispose()
    }
  },
  methods: {
    init () {
      const unit = this.config.chartSet.chartStyle.unit
      this.option = _.merge(_.cloneDeep(gaugeBaseOption), {
        series: [
          {
            max: this.config.chartSet.chartStyle.max,
            color: this.borderColor,
            axisLabel: {
              show: this.config.chartSet.chartStyle.axisLabel,
            },
            pointer: {
              length: this.config.chartSet.chartStyle.arrowLength,
            },
            detail: {
              formatter: (value) => {
                return `{value|${getNumberFormat(value)}}{unit|${unit}}`
              },
              rich: {
                value: {
                  fontSize: this.config.chartSet.chartStyle.fontSize,
                  color: this.config.chartSet.chartStyle.color,
                },
                unit: {
                  fontSize: this.config.chartSet.chartStyle.fontSize,
                  color: this.config.chartSet.chartStyle.color,
                },
              },
            },
            data: [
              {
                value: this.curNumber,
              },
            ],
          },
        ],

      })
      this.echarts.setOption(this.option, true)
    },
  },
}
</script>

<style lang='scss' scoped>
.gauge {
  display: flex;
  flex-direction: column;
  position: relative;
  &-chart-title{
    // position:absolute;
    // top: 0;
    // bottom:20px;
    padding: 0 10px;
    margin-top: -24px;
  }
  .gauge-container{
    flex: 1;
  }

}

</style>
